var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container bng-narrow-container bng-withdrawal-codes"},[(!_vm.haveWithdrawalPins)?_c('div',{},[_vm._v(_vm._s(_vm._f("translate")("components.pages.withdrawal-codes.no codes")))]):_vm._e(),_vm._v(" "),_c('withdrawal-codes-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib??vue-loader-options!./skins/bulmasite/components/pages/sitepages/withdrawal-codes/withdrawal-codes.vue?vue&type=template&id=75e3ca2f
// module id = eytX
// module chunks = 0